import request from '@/utils/httpRequest'

export default class InfacyProjectReceptionService {
    queryById(id) {
        return request({
            url: '/infacy/wuyeInfacyProjectReception/queryById',
            method: 'get',
            params: { id: id }
        })
    }

    startFlow(params) {
        return request({
            url: '/infacy/wuyeInfacyProjectReception/startFlow',
            method: 'post',
            data: params
        })
    }

}
